module.exports = __webpack_public_path__ + "files/6558f1efe3c26e05f555945f746f3f4a.png";